import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import { loginCover, logo } from "../../assets/images";
import { useSelector } from "react-redux";

export default function Register() { 
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (user.isLoggedIn) {
      navigate("/");
    }

    if (error) {
      const timeout = setTimeout(() => {
        setError(""); // Hata mesajını temizle
      }, 3000);

      return () => clearTimeout(timeout);
    }

    if (msg) {
      const timeout = setTimeout(() => {
        setMsg(""); // Mesajı temizle
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [user.isLoggedIn, error, msg, navigate]);

  const handleInputChange = (e, type) => {
    const value = e.target.value;
    setError("");

    switch (type) {
      case "name":
        setName(value);
        break;
      case "surname":
        setSurname(value);
        break;
      case "email":
        setEmail(value);
        if (value === "") {
          setError(t("Email boş ola bilməz"));
        }
        break;
      case "mobile":
        setMobile(value);
        if (value === "") {
          setError(t("Nömrə boş ola bilməz"));
        }
        break;
      case "password":
        setPassword(value);
        if (value === "") {
          setError(t("Şifrə boş ola bilməz"));
        }
        break;
      default:
        break;
    }
  };

const loginSubmit = async (e) => {
  e.preventDefault();

  try {
    // Yeni istifadəçi üçün məlumatları hazırlayırıq
    const formData = new FormData();

    formData.append("name", name);
    formData.append("surname", surname);
    formData.append("email", email.trim().toLowerCase());
    formData.append("mobile", mobile);
    formData.append("password", password);

    // Birbaşa POST göndəririk.
    // Email-in mövcud olub-olmadığını backend yoxlayır.
    const postResponse = await axios.post(
      "https://www.elzabeauty.az/elza/users.php",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // Backend uğurlu qeydiyyat
    if (
      postResponse.status === 200 &&
      postResponse.data.status === 1
    ) {
      toast.success(
        t("Qeydiyyat uğurla tamamlandı. Email ünvanınızı yoxlayın.")
      );

      navigate(`/${currentLanguage}/login`);
      return;
    }

    // Backend email-in artıq mövcud olduğunu bildirirsə
    if (
      postResponse.data.status === 0 &&
      postResponse.data.message === "Bu email artıq qeydiyyatdan keçib"
    ) {
      toast.error(t("Bu email artıq qeydiyyatdan keçib"));
      return;
    }

    // Digər backend xətaları
    toast.error(
      postResponse.data.message ||
      t("Qeydiyyat zamanı xəta baş verdi")
    );

  } catch (error) {
    console.error("Server xətası:", error);

    // Backend-dən gələn error response varsa onu göstər
    if (error.response?.data?.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error(t("Server xətası baş verdi"));
    }
  }
};


  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      <div className="bg-[#F4F4F4] py-[40px] md:py-[80px]">
        <div className="max-w-containerSm md:max-w-container mx-auto">
          <div data-aos="fade-up" className="md:flex justify-between">
            <div className="md:w-[612px] flex items-center">
              <div className="w-full">
                <img alt="Logo" className="w-[50px] md:w-[80px] mx-auto" src={logo}></img>
                <p className=" text-[#222] text-[28px] md:text-[52px] font-bold text-center">
                  {t("Qeydiyyatdan Keç")}
                </p>
                <p className="text-[#5B5F62] text-[14px] md:text-[16px] mt-4 text-center">
                  {t(
                    "Elza Beauty ailəsinə qoşul, bonuslar və sürprizlərdən yararlan!"
                  )}
                </p>
                <form className="mt-6 md:mt-8 space-y-6" onSubmit={loginSubmit}>
                  <div>
                    <p className="text-thirdColor text-[14px]">{t("Ad")}</p>
                    <input
                      name="name"
                      className="rounded-lg h-[48px] w-full p-4 border-[1px] border-[#CFCFCF] mt-2 outline-none focus:ring-0 focus:outline-none"
                      placeholder={t("Adınızı daxil edin")}
                      value={name}
                      onChange={(e) => handleInputChange(e, "name")}
                      required
                    />
                  </div>
                  <div>
                    <p className="text-thirdColor text-[14px]">{t("Soyad")}</p>
                    <input
                      name="surname"
                      className="rounded-lg h-[48px] w-full p-4 border-[1px] border-[#CFCFCF] mt-2 outline-none focus:ring-0 focus:outline-none"
                      placeholder={t("Soyadınızı daxil edin")}
                      value={surname}
                      onChange={(e) => handleInputChange(e, "surname")}
                      required
                    />
                  </div>
                  <div>
                    <p className="text-thirdColor text-[14px]">{t("E-poçt")}</p>
                    <input
                      type="email"
                      name="email"
                      className="rounded-lg h-[48px] w-full p-4 border-[1px] border-[#CFCFCF] mt-2 outline-none focus:ring-0 focus:outline-none"
                      placeholder={t("E-poçtunuzu daxil edin")}
                      value={email}
                      onChange={(e) => handleInputChange(e, "email")}
                      required
                    />
                    <p className="text-thirdColor text-[14px] mt-5">
                      {t("Nömrə")}
                    </p>
                    <input
                      type="number"
                      name="mobile"
                      className="rounded-lg h-[48px] w-full p-4 border-[1px] border-[#CFCFCF] mt-2 outline-none focus:ring-0 focus:outline-none"
                      placeholder={t("Nömrənizi daxil edin")}
                      value={mobile}
                      onChange={(e) => handleInputChange(e, "mobile")}
                      required
                    />
                  </div>

                  <div>
                    <p className="text-thirdColor text-[14px] mt-5">
                      {t("Şifrə")}
                    </p>
                    <input
                      type="password"
                      name="password"
                      className="rounded-lg h-[48px] w-full p-4 border-[1px] border-[#CFCFCF] mt-2 outline-none focus:ring-0 focus:outline-none"
                      value={password}
                      onChange={(e) => handleInputChange(e, "password")}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full h-[44px] rounded-2xl bg-[#181D27] text-white mt-[48px] transition-colors"
                  >
                    {t("Daxil Ol")}
                  </button>
                  <a href={`/${currentLanguage}/login`}>
                    {" "}
                    <p className="text-[#222] text-[14px] mt-4 font-bold text-center">
                      {t("Artıq hesabınız var? Daxil Ol")}
                    </p>
                  </a>
                </form>
              </div>
            </div>
            <div className="md:w-[612px] text-firstColor mt-6 md:mt-0 hidden md:block">
              <img alt="Login" src={loginCover}></img>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
